<template>
  <div>
    <v-card class="card" link to="/menu/mk/sandwich">
      <v-card-title>Сендвичи</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/mk/toast">
      <v-card-title>Тостови</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/mk/pizza">
      <v-card-title>Пица</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/mk/salads">
      <v-card-title>Салати</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/mk/beverage">
      <v-card-title>Пијалоци</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/mk/sides">
      <v-card-title>Додатоци</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/mk/icecream">
      <v-card-title>Сладолед</v-card-title>
    </v-card>
  </div>
</template>

<style scoped>
.card {
  border-radius: 12px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.99);
  padding: 0.3rem;
  margin: 1.2rem auto;
  max-width: 18rem;
  text-align: center;
}
.button {
  background-color: #dc143c;
  color: white;
  max-width: 100px;
}
</style>
<script setup>
</script>